import React, { FC, useCallback, useState, useRef } from 'react';
import styles from './index.module.scss';
import { EditableText } from 'src/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { BoxFieldString } from 'src/models/procurements';
import { IBoxFieldString } from 'src/models/procurements/Tender/types';
import { useClickAway } from 'react-use';
import { useTask, useUpdateBidTasks } from 'src/models/bids/BidTask/hooks';

export const BidTaskHeader: FC = () => {
  const { data: task } = useTask();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [updateTasks] = useUpdateBidTasks();

  const [editMode, setEditMode] = useState(false);
  const editModeOn = useCallback(() => {
    setEditMode(true);
  }, []);
  const editModeOff = useCallback(() => {
    setEditMode(false);
  }, []);

  useClickAway(ref, e => {
    e.stopPropagation();
    e.preventDefault();
    editModeOff();
  });

  const onSubmit = useCallback(
    (field: IBoxFieldString) => {
      task &&
        task.groupId &&
        updateTasks({
          questions: [task],
          groupId: task.groupId,
          title: field.string ?? ''
        });
      editModeOff();
    },
    [editModeOff, task, updateTasks]
  );

  return (
    <>
      {task && (
        <div className={styles.title}>
          {editMode ? (
            <EditableText
              className={styles.editableName}
              containerRef={ref}
              onChange={onSubmit}
              field={new BoxFieldString(task.title ?? '', task.title)}
              autoSize={true}
              autoFocus
            />
          ) : (
            <div className={styles.plainName} onClick={editModeOn}>
              <span className={styles.text}>{!!task.title ? task.title : t('BiddingTool.newTaskPlaceholder')}</span>
              <FontAwesomeIcon icon={faPen} className={styles.editIcon} />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BidTaskHeader;
